import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
    selector: 'app-edit-data-popup',
    templateUrl: './edit-data-popup.component.html',
    styleUrls: ['./edit-data-popup.component.css'],
    standalone: false
})
export class EditDataPopupComponent {
  createRoleform: FormGroup;
  updateAppAttrForm: FormGroup;
  updateLookUpHryForm: FormGroup;
  updateLookUpNoHryForm: FormGroup;
  addUpdateLookUpHryForm: FormGroup;
  addUpdateLookUpNoHryForm: FormGroup;
  addUpdateUIdynamicContentForm: FormGroup;
  updateVideoLibraryForm: FormGroup;
  @Input() dataToEdit: any = {};
  @Input() formfields: any = [];
  @Input() tableName: string = '';
  @Input() editFlag: boolean = false;
  @Input() closePopup:boolean = false;
  @Output() emitReqPayload: EventEmitter<any> = new EventEmitter();
  reqPayload: any;
  formName: string;
  selectedValue: any = [];
  text:boolean = false;
  btnName:string = "Create New";

  constructor(private formBuilder: FormBuilder) {
    this.createRoleform = this.formBuilder.group({
      workQueue: [{value:"",disabled: true}, [Validators.required]],
      createReqRole: ['', [Validators.required]],
      approveReqRole: ['', [Validators.required]],
      createDropdown: ['', [Validators.required]],
      viewVisibility: ['', [Validators.required]]
    });
    this.updateAppAttrForm = this.formBuilder.group({
      attribute:[{value:"",disabled: true}, [Validators.required]],
      selection: [{value:"",disabled: true}, [Validators.required]],
      hierarchy: [{value:"",disabled: true}, [Validators.required]],
      editable: ['', [Validators.required]],
      visualorder: ['', [Validators.required]]
    });
    this.updateLookUpHryForm = this.formBuilder.group({
      attributeHry: [{value:"",disabled: true}, [Validators.required]],
      valueHry: ["", [Validators.required]],
      subvalueHry: ['', [Validators.required]],
      editDropdownHry: ['', [Validators.required]],
      viewDropdownHry: ['', [Validators.required]]
    });
    this.addUpdateLookUpHryForm = this.formBuilder.group({
      attributeHry: [{value:"",disabled: false}, [Validators.required]],
      valueHry: ['', [Validators.required]],
      subvalueHry: ['', [Validators.required]],
      editDropdownHry: ['', [Validators.required]],
      viewDropdownHry: ['', [Validators.required]]
    });
    this.addUpdateLookUpNoHryForm = this.formBuilder.group({
      attributeHry: [{value:"",disabled: false}, [Validators.required]],
      valueHry: ['', [Validators.required]],
      editDropdownHry: ['', [Validators.required]],
      viewDropdownHry: ['', [Validators.required]]
    });
    this.updateLookUpNoHryForm = this.formBuilder.group({
      attribute: [{value:"",disabled: true}, [Validators.required]],
      value: ['', [Validators.required]],
      editDropdown: ['', [Validators.required]],
      viewDropdown: ['', [Validators.required]]
    });
    this.addUpdateUIdynamicContentForm = this.formBuilder.group({ 
      PageName: ['', [Validators.required]],
      Catagory: ['', [Validators.required]],
      Audience: ['', [Validators.required]],
      Occurance: ['', [Validators.required]],
      Description: [''],
      SubTitle: [''],
      CostData: ['', [Validators.required]],
      Url_Path: [''],
      Content: ['', [Validators.required]],
      visibility: ['False', [Validators.required]],
      Popup: ['False', [Validators.required]],
      Role_Visibility: ['', [Validators.required]],
      icon: [''],
    });

     this.updateVideoLibraryForm = this.formBuilder.group({ 
      title: ['', [Validators.required]],
      category: ['', [Validators.required]],
      video_blobname: ['', [Validators.required]],
      vtt_text: ['', [Validators.required]],
    });
  }

  checkFormFilled(){
    return (this.addUpdateLookUpHryForm.status == 'VALID' ? false : true);
  }
  checkNoHryFormFilled(){
    return (this.addUpdateLookUpNoHryForm.status == 'VALID' ? false : true);
  }

  checkDynamicContentFormFilled(){
    if(this.editFlag){
      return (this.addUpdateUIdynamicContentForm.status == 'VALID' && this.checkIsValueChanged() ? false : true);
    }else{
      return (this.addUpdateUIdynamicContentForm.status == 'VALID' ? false : true);
    }
  }

  checkVideoLibraryFormFieled(){
    if(this.editFlag){
      return (this.updateVideoLibraryForm.status == 'VALID' ? false : true);
    }else{
      return (this.updateVideoLibraryForm.status == 'VALID' ? false : true);
    }
  }

  toggleInput(){
    this.btnName = this.text ?  'Create New' : 'Existing Value';
   this.text = !this.text;
  }

  ngOnChanges() {
    if (this.editFlag) {
      this.handleEditMode();
    } else {
      this.addUpdateUIdynamicContentForm.reset();
    }

    if (this.closePopup) {
      this.resetFormValue();
    }
  }

  private handleEditMode() {
    if (!this.dataToEdit) return;

    switch (this.tableName) {
      case "WQ_MSTR":
        this.populateWQMstrForm();
        break;
      case "APP_ATTR":
        this.populateAppAttrForm();
        break;
      case "LOOKUP_NO_HRY":
        this.populateLookUpNoHryForm();
        break;
      case "LOOKUP_WITH_HRY":
        this.populateLookUpHryForm();
        break;
      case "UI_DYNAMIC_CONTENT_TABLE":
        this.populateUIDynamicContentForm();
        break;
      case "VIDEO_LIBRARY":
        this.populateVideoLibraryForm();
        break;
    }
  }

  private populateWQMstrForm() {
    const createReqRoleDD = this.formfields.filter(x => x.fcname == 'createReqRole');
    const create_req_roles = createReqRoleDD[0].dropdownData.filter(x => 
      this.dataToEdit.create_req_roles.split(",").includes(x.id)
    );
    const approveReqRoleDD = this.formfields.filter(x => x.fcname == 'approveReqRole');
    const approve_req_roles = approveReqRoleDD[0].dropdownData.filter(x => 
      this.dataToEdit.approve_req_roles.split(",").includes(x.id)
    );
    
    this.createRoleform.setValue({
      workQueue: this.dataToEdit.workqueue,
      createReqRole: create_req_roles,
      approveReqRole: approve_req_roles,
      createDropdown: this.dataToEdit.create_new_dropdown,
      viewVisibility: this.dataToEdit.view_visibility
    });
    
    this.setSelectedDropdownValues("approveReqRole", approve_req_roles);
    this.setSelectedDropdownValues("createReqRole", create_req_roles);
  }

  private populateAppAttrForm() {
    this.updateAppAttrForm.setValue({
      attribute: this.dataToEdit.attribute_name,
      selection: this.dataToEdit.selection,
      hierarchy: this.dataToEdit.hierarchy,
      editable: this.dataToEdit.editable,
      visualorder: this.dataToEdit.visual_order
    });
  }

  private populateLookUpNoHryForm() {
    this.updateLookUpNoHryForm.setValue({
      attribute: this.dataToEdit.attribute,
      value: this.dataToEdit.value,
      editDropdown: this.dataToEdit.edit_drop_down,
      viewDropdown: this.dataToEdit.view_drop_down
    });
  }

  private populateLookUpHryForm() {
    this.updateLookUpHryForm.setValue({
      attributeHry: this.dataToEdit.attribute,
      valueHry: this.dataToEdit.value,
      subvalueHry: this.dataToEdit.sub_value,
      editDropdownHry: this.dataToEdit.edit_drop_down,
      viewDropdownHry: this.dataToEdit.view_drop_down
    });
  }

  private populateUIDynamicContentForm() {
    this.addUpdateUIdynamicContentForm.setValue({
      PageName: this.sanitizeValue(this.dataToEdit.PageName),
      Catagory: this.sanitizeValue(this.dataToEdit.Catagory),
      Audience: this.sanitizeValue(this.dataToEdit.Audience),
      Occurance: this.dataToEdit.Occurance == null ? '' : this.dataToEdit.Occurance,
      Description: this.sanitizeValue(this.dataToEdit.Description),
      SubTitle: this.sanitizeValue(this.dataToEdit.SubTitle),
      CostData: this.sanitizeValue(this.dataToEdit.CostData),
      Url_Path: this.sanitizeValue(this.dataToEdit.Url_Path),
      Content: this.sanitizeValue(this.dataToEdit.Content),
      visibility: this.dataToEdit.visibility,
      Popup: this.dataToEdit.Popup,
      Role_Visibility: this.sanitizeValue(this.dataToEdit.Role_Visibility),
      icon: this.sanitizeValue(this.dataToEdit.icon)
    });
  }

  private populateVideoLibraryForm() {
    this.updateVideoLibraryForm.setValue({
      title: this.sanitizeValue(this.dataToEdit.title),
      category: this.sanitizeValue(this.dataToEdit.category),
      video_blobname: this.sanitizeValue(this.dataToEdit.video_blobname),
      vtt_text: this.sanitizeValue(this.dataToEdit.vtt_text)
    });
  }

  private sanitizeValue(value: any): string {
    return (value == null || value.toLowerCase() == 'null') ? '' : value;
  }

  submitForm() {
    switch (this.tableName) {
      case "WQ_MSTR":
        this.submitWQMstrForm();
        break;
      case "APP_ATTR":
        this.submitAppAttrForm();
        break;
      case "LOOKUP_NO_HRY":
        this.submitLookUpNoHryForm();
        break;
      case "LOOKUP_WITH_HRY":
        this.submitLookUpHryForm();
        break;
    }
  }

  private submitWQMstrForm() {
    this.reqPayload = {
      tableName: "WQ_MSTR",
      payload: this.dataToEdit
    };
    
    const create_req_roles = this.selectedValue.createReqRole.map(x => x.name);
    this.reqPayload.payload["create_req_roles"] = create_req_roles.join(",");
    this.reqPayload.payload["approve_req_roles"] = this.selectedValue.approveReqRole.map(x => x.name).join(",");
    this.reqPayload.payload["create_new_dropdown"] = this.createRoleform.value.createDropdown;
    this.reqPayload.payload["view_visibility"] = this.createRoleform.value.viewVisibility;
    
    this.emitReqPayload.emit(this.reqPayload);
  }

  private submitAppAttrForm() {
    this.reqPayload = {
      tableName: "APP_ATTR",
      payload: this.dataToEdit
    };
    
    this.reqPayload.payload["selection"] = this.updateAppAttrForm.value.selection;
    this.reqPayload.payload["heirarchy"] = this.updateAppAttrForm.value.heirarchy;
    this.reqPayload.payload["editable"] = this.updateAppAttrForm.value.editable;
    this.reqPayload.payload["visual_order"] = this.updateAppAttrForm.value.visualorder;
    
    this.emitReqPayload.emit(this.reqPayload);
  }

  private submitLookUpNoHryForm() {
    this.reqPayload = {
      tableName: "LOOKUP_NO_HRY",
      payload: this.dataToEdit
    };
    
    this.reqPayload.payload["attribute"] = this.updateLookUpNoHryForm.get('attribute').value;
    this.reqPayload.payload["value"] = this.updateLookUpNoHryForm.value.value;
    this.reqPayload.payload["edit_drop_down"] = this.updateLookUpNoHryForm.value.editDropdown;
    this.reqPayload.payload["view_drop_down"] = this.updateLookUpNoHryForm.value.viewDropdown;
    
    this.emitReqPayload.emit(this.reqPayload);
  }

  private submitLookUpHryForm() {
    this.reqPayload = {
      tableName: "LOOKUP_WITH_HRY",
      payload: this.dataToEdit
    };
    
    this.reqPayload.payload["attribute"] = this.updateLookUpHryForm.get('attributeHry').value;
    this.reqPayload.payload["value"] = this.updateLookUpHryForm.value.valueHry;
    this.reqPayload.payload["sub_value"] = this.updateLookUpHryForm.value.subvalueHry;
    this.reqPayload.payload["edit_drop_down"] = this.updateLookUpHryForm.value.editDropdownHry;
    this.reqPayload.payload["view_drop_down"] = this.updateLookUpHryForm.value.viewDropdownHry;
    
    this.emitReqPayload.emit(this.reqPayload);
  }

  addLookupHry() {
    this.reqPayload = {
      "tableName": "ADD_LOOKUP_WITH_HRY"
    }

    this.reqPayload.payload = {
      "attribute": this.addUpdateLookUpHryForm.value.attributeHry,
      "value": this.addUpdateLookUpHryForm.value.valueHry,
      "sub_value": this.addUpdateLookUpHryForm.value.subvalueHry,
      "edit_drop_down": this.addUpdateLookUpHryForm.value.editDropdownHry,
      "view_drop_down": this.addUpdateLookUpHryForm.value.viewDropdownHry,
    }
   
     this.emitReqPayload.emit(this.reqPayload);

  }

  addLookupNoHry() {
    this.reqPayload = {
      "tableName": "ADD_LOOKUP_WITH_NO_HRY"
    }

    this.reqPayload.payload = {
      "attribute": this.addUpdateLookUpNoHryForm.value.attributeHry,
      "value": this.addUpdateLookUpNoHryForm.value.valueHry,
      "edit_drop_down": this.addUpdateLookUpNoHryForm.value.editDropdownHry,
      "view_drop_down": this.addUpdateLookUpNoHryForm.value.viewDropdownHry,
    }

    this.emitReqPayload.emit(this.reqPayload);
  }

  addDynamicContent(){
    this.reqPayload = {
      "tableName": "UI_DYNAMIC_CONTENT_TABLE"
    }

    this.reqPayload.payload = {
      PageName: this.addUpdateUIdynamicContentForm.value.PageName,
      Catagory: this.addUpdateUIdynamicContentForm.value.Catagory,
      Audience: this.addUpdateUIdynamicContentForm.value.Audience,
      Occurance: this.addUpdateUIdynamicContentForm.value.Occurance,
      Description: this.addUpdateUIdynamicContentForm.value.Description,
      SubTitle: this.addUpdateUIdynamicContentForm.value.SubTitle,
      CostData: this.addUpdateUIdynamicContentForm.value.CostData,
      Url_Path: this.addUpdateUIdynamicContentForm.value.Url_Path,
      Content: this.addUpdateUIdynamicContentForm.value.Content,
      visibility: this.addUpdateUIdynamicContentForm.value.visibility,
      Popup: this.addUpdateUIdynamicContentForm.value.Popup,
      Role_Visibility: this.addUpdateUIdynamicContentForm.value.Role_Visibility,
      icon: this.addUpdateUIdynamicContentForm.value.icon, 
    }
    if(this.editFlag){
      this.reqPayload.payload["ID"] = this.dataToEdit.id;
    }

    this.emitReqPayload.emit(this.reqPayload);
  }

   updateVideoLibrary(){
    this.reqPayload = {
      "tableName": "VIDEO_LIBRARY"
    }

    this.reqPayload.payload = {
      title: this.updateVideoLibraryForm.value.title,
      category: this.updateVideoLibraryForm.value.category,
      video_blobname: this.updateVideoLibraryForm.value.video_blobname,
      vtt_text: this.updateVideoLibraryForm.value.vtt_text
    }
    if(this.editFlag){
      this.reqPayload.payload["ID"] = this.dataToEdit.id;
    }
    this.emitReqPayload.emit(this.reqPayload);
  }

  resetFormValue(){
    this.addUpdateLookUpNoHryForm.reset();
    this.addUpdateLookUpHryForm.reset();
    this.addUpdateUIdynamicContentForm.reset();
  }



  setSelectedDropdownValues(field, data) {
    this.selectedValue[field] = data;
  }

  setSelectedValues(data,type) {
    if (type == "Select Create Req Roles")
      this.selectedValue.createReqRole = data.data;

    else if (type == "Select Approve Req Roles") {
      this.selectedValue.approveReqRole = data.data;
    }
  }

  isValidNumber(event,key,type){
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    if(type == 'UI_DYNAMIC_CONTENT_TABLE'){
      this.addUpdateUIdynamicContentForm.controls[key].setValue(event.target.value);
    }
  }

  checkIsValueChanged() {
    let isAnyValueChange = false;
    const res = this.addUpdateUIdynamicContentForm.value;
    if (res.PageName != this.dataToEdit.PageName ||
      res.Catagory != this.dataToEdit.Catagory ||
      res.Audience != this.dataToEdit.Audience ||
      res.Occurance != this.dataToEdit.Occurance ||
      (((this.dataToEdit.Description == null || this.dataToEdit.Description == '') && res.Description) || (!(this.dataToEdit.Description == null || this.dataToEdit.Description == '') && res.Description != this.dataToEdit.Description)) ||
      (((this.dataToEdit.SubTitle == null || this.dataToEdit.SubTitle == '') && res.SubTitle) || (!(this.dataToEdit.SubTitle == null || this.dataToEdit.SubTitle == '') && res.SubTitle != this.dataToEdit.SubTitle)) ||
      res.Content != this.dataToEdit.Content ||
      res.CostData != this.dataToEdit.CostData ||
      (((this.dataToEdit.Url_Path == null || this.dataToEdit.Url_Path == '') && res.Url_Path) || (!(this.dataToEdit.Url_Path == null || this.dataToEdit.Url_Path == '') && res.Url_Path != this.dataToEdit.Url_Path)) ||
      res.Content != this.dataToEdit.Content ||
      res.visibility != this.dataToEdit.visibility ||
      res.Popup != this.dataToEdit.Popup ||
      res.Role_Visibility != this.dataToEdit.Role_Visibility ||
      (((this.dataToEdit.icon == null || this.dataToEdit.icon == '') && res.icon) || (!(this.dataToEdit.icon == null || this.dataToEdit.icon == '') && res.icon != this.dataToEdit.icon))
    ) {
      isAnyValueChange = true;
    }
    return isAnyValueChange;
  }

}
